export default __webpack_public_path__ + "static/media/ps-LightFixture1.4c7d5565.png";